import { z } from 'zod';
import {
  AdminCreateBillingEntityDomainClaimRequestSchema,
  CreateBillingEntityDomainClaimRequestSchema,
  isUnclaimableDomain,
} from '@reflex/shared';
import { UNCLAIMABLE_DOMAIN_COPY } from './claim-error-copy';

/**
 * The server's domain field, lower-cased and checked against the same
 * unclaimable list the server uses so a doomed request is never sent.
 * Shared by the customer and platform-admin claim forms.
 */
const ClaimDomainFieldSchema = CreateBillingEntityDomainClaimRequestSchema.shape.domain
  .toLowerCase()
  .refine((domain) => !isUnclaimableDomain(domain), UNCLAIMABLE_DOMAIN_COPY);

/** Customer claim form: the server request schema with the client-side domain check. */
export const claimDomainSchema = CreateBillingEntityDomainClaimRequestSchema.extend({
  domain: ClaimDomainFieldSchema,
});
export type ClaimDomainForm = z.input<typeof claimDomainSchema>;

/** Platform-admin claim form: the same domain check plus the audited reason. */
export const adminClaimDomainSchema = AdminCreateBillingEntityDomainClaimRequestSchema.extend({
  domain: ClaimDomainFieldSchema,
});
export type AdminClaimDomainForm = z.input<typeof adminClaimDomainSchema>;
